<template>
  <v-card class="pa-5 elevation-5">
    <v-row class="pa-0 ma-0">
      <v-col class="mx-auto text-center" cols="12" v-if="usersProfileData.profileImageUrl">
        <v-avatar class="profile" color="grey" size="120">
          <v-img :src="usersProfileData.profileImageUrl"></v-img>
        </v-avatar>
      </v-col>
      <v-col class="pa-0" v-if="!editFlag">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="my-1">تلفن همراه : {{ usersProfileData.phoneNumber }}</v-list-item-title>
            <v-list-item-title class="my-1">نقش : {{ rolesValue[usersProfileData.role] }}</v-list-item-title>
            <template v-if="usersProfileData.role == 'normal'">
              <v-list-item-title class="text-h4">
              <span>
                نام و نام خانوادگی:
              {{ usersProfileData.fullName }}
              </span>

              </v-list-item-title>
            </template>
            <template v-if="usersProfileData.role == 'reporter'">
              <v-list-item-title class="text-h4">
              <span>
                نام و نام خانوادگی:
              {{ usersProfileData.fullName }}
              </span>

              </v-list-item-title>
              <v-list-item-title class="my-1">نام رسانه : {{ usersProfileData.mediaName }}</v-list-item-title>
<!--              <v-list-item-title class="my-1">کد خبرنگاری  : {{ usersProfileData.reporterCode }}</v-list-item-title>-->
              <!--              <v-list-item-subtitle v-if="usersProfileData.aboutMe">درباره من : {{ usersProfileData.aboutMe }} </v-list-item-subtitle>-->
            </template>
            <template v-if="usersProfileData.role == 'organization'">
              <v-list-item-title class="text-h4">نام نماینده: {{ usersProfileData.fullName }}  </v-list-item-title>
              <v-list-item-title class="my-1">نام سازمان : {{ usersProfileData.organizationName }}</v-list-item-title>
            </template>
            <template v-if="usersProfileData.role == 'attorney' || usersProfileData.role == 'expert'">
              <v-list-item-title class="text-h4">
              <span>
                نام و نام خانوادگی:
              {{ usersProfileData.fullName }}
              </span>

              </v-list-item-title>
              <v-list-item-title class="my-1">کدملی  : {{ usersProfileData.nationalCode }}</v-list-item-title>
              <v-list-item-title class="my-1"  v-if="usersProfileData.role == 'attorney' ">کد پروانه وکالت  : {{ usersProfileData.licenseCode }}</v-list-item-title>
              <v-list-item-title class="my-1">ایمیل  : {{ usersProfileData.email }}</v-list-item-title>
              <v-list-item-title class="my-1">آی دی اینستاگرام  : {{ usersProfileData.instagramId }}</v-list-item-title>
              <v-list-item-title class="my-1">آی دی توئیتر  : {{ usersProfileData.twitterId }}</v-list-item-title>
              <v-list-item-title class="my-1">تلفن دفتر  : {{ usersProfileData.officeNumber }}</v-list-item-title>
              <v-list-item-title class="my-1">آدرس دفتر  : {{ usersProfileData.officeAddress }}</v-list-item-title>
              <v-list-item-title class="my-1">درباره من  : {{ usersProfileData.aboutMe }}</v-list-item-title>
            </template>

          </v-list-item-content>
        </v-list-item>
        <v-btn v-if="!editFlag" class="primary" dark @click="editFlag = true">ویرایش</v-btn>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0" v-if="editFlag">
      <template v-if="usersProfileData.role =='normal'">
        <v-col cols="12" lg="12">
          <v-text-field
            label="نام و نام خانوادگی"
            outlined
            dense
            v-model="fullName"
          ></v-text-field>
        </v-col>
      </template>
      <template v-if="usersProfileData.role =='reporter'">
        <v-col cols="12" lg="12">
          <v-text-field
            label="نام و نام خانوادگی"
            outlined
            dense
            v-model="fullName"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12">
          <v-text-field
            label="نام رسانه"
            outlined
            dense
            v-model="mediaName"
          ></v-text-field>
        </v-col>
<!--        <v-col cols="12" lg="12">-->
<!--          <v-text-field-->
<!--            label="کد خبرنگاری "-->
<!--            outlined-->
<!--            dense-->
<!--            v-model="reporterCode"-->
<!--          ></v-text-field>-->
<!--        </v-col>-->
      </template>
      <template v-if="usersProfileData.role == 'attorney' || usersProfileData.role == 'expert'">
        <v-col cols="12" lg="12">
          <v-text-field
            label="نام و نام خانوادگی"
            outlined
            dense
            v-model="fullName"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12">
          <v-text-field
            label="کدملی"
            outlined
            dense
            v-model="nationalCode"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12" v-if="usersProfileData.role == 'attorney' ">
          <v-text-field
            label="کد پروانه وکالت"
            outlined
            dense
            v-model="licenseCode"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12">
          <v-text-field
            label="ایمیل"
            outlined
            dense
            v-model="email"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12">
          <v-text-field
            label="آی دی اینستاگرام"
            outlined
            dense
            v-model="instagramId"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12">
          <v-text-field
            label="آی دی توئیتر"
            outlined
            dense
            v-model="twitterId"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12">
          <v-text-field
            label="تلفن دفتر"
            outlined
            dense
            v-model="officeNumber"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="12">
          <v-textarea
            outlined
            name="input-7-4"
            label="آدرس دفتر  "
            v-model="officeAddress"
          ></v-textarea>
        </v-col>
        <v-col cols="12" lg="12">
          <v-textarea
            outlined
            name="input-7-4"
            label="درباره من "
            v-model="aboutMe"
          ></v-textarea>
        </v-col>
      </template>
      <v-btn class="primary" dark @click="confirmEdit">تائید</v-btn>
    </v-row>
  </v-card>

</template>

<script>
export default {
  name: "userProfile",
  props: {
    userId: {
      type: String,
      default: "",
      required: true,
    },
    // dialogProfile: {
    //   type: Boolean,
    //   default: false,
    //   required: true,
    // },
  },
  data() {
    return {
      role: {
        "normal": "کاربر عادی",
        "consultant": "مشاور",
        "admin": "ادمین",
      },
      rolesValue: {
        superAdmin: "ادمین ویژه",
        admin: "ادمین",
        organization: "سازمان",
        reporter: "خبرنگار",
        expert: "متخصص",
        attorney: "وکیل",
        normal: "کاربر عادی",
      },
      statusValue: {
        true: "فعال",
        false: "غیر فعال",
      },
      searchRole: {name: '', value: ''},
      searchRoles: [
        {name: "کاربر عادی", value: "normal"},
        {name: "ادمین", value: "admin"},
        {name: "ادمین ویژه", value: "superAdmin"},
        {name: "سازمان", value: "organization"},
        {name: "خبرنگار", value: "reporter"},
        {name: "متخصص", value: "expert"},
        {name: "وکیل", value: "attorney"},
      ],

      newState: {name: '', value: ''},
      states: [
        {name: "ثبت نام شده", value: "registered"},
        {name: "تایید شده", value: "verified"},
        {name: "ثبت نام شده", value: "registered"},
        {name: "رد شده", value: "rejected"},
        {name: "غیر فعال", value: "deactivated"},
      ],
      editFlag: false,
      fullName: '',
      nationalCode: '',
      email: '',
      aboutMe: '',
      mediaName:'',
      reporterCode:'',
      organizationName:'',
      licenseCode:'',
      instagramId:'',
      twitterId:'',
      officeNumber:'',
      officeAddress:'',


    }
  },
  mounted() {
  },
  computed: {
    usersProfileData: {
      get() {
        return this.$store.getters["userManagement/getUserProfile"];
      },
      set(value) {
      },
    },

  },
  watch: {
    userId: {
      async handler() {
        if (this.userId != '') {
          await this.$store.dispatch("userManagement/fetchUserProfile", {
            id: this.userId,
          });
          this.fullName = this.usersProfileData.fullName;
          if (this.usersProfileData.role == 'reporter'){
            this.mediaName = this.usersProfileData.mediaName;
            this.reporterCode = this.usersProfileData.reporterCode;
          }else if(this.usersProfileData.role == 'organization'){
            this.licenseCode = this.usersProfileData.licenseCode;
          }else if(this.usersProfileData.role == 'expert' || this.usersProfileData.role == 'attorney'){
            this.nationalCode = this.usersProfileData.nationalCode;
            this.email = this.usersProfileData.email;
            this.aboutMe = this.usersProfileData.aboutMe;
            this.licenseCode = this.usersProfileData.licenseCode;
            this.instagramId = this.usersProfileData.instagramId;
            this.twitterId = this.usersProfileData.twitterId;
            this.officeNumber = this.usersProfileData.officeNumber;
            this.officeAddress = this.usersProfileData.officeAddress;
          }

        }

      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async confirmEdit() {
      let jsonData = null;
      if (this.usersProfileData.role == 'normal') {
        jsonData =
          {
            "fullName": this.fullName,
          }
      }else if(this.usersProfileData.role == 'reporter'){
        jsonData =
          {
            "fullName": this.fullName,
            "mediaName" : this.mediaName,
            "reporterCode" : this.reporterCode,
          }
      }else if(this.usersProfileData.role == 'organization'){
        jsonData =
          {
            "fullName": this.fullName,
            "organizationName" : this.organizationName,
          }
      }else if(this.usersProfileData.role == 'attorney'){
        jsonData =
          {
            "fullName": this.fullName,
            "nationalCode" : this.nationalCode,
            "licenseCode": this.licenseCode,
            "email" : this.email,
            "instagramId": this.instagramId,
            "twitterId" : this.twitterId,
            "officeNumber": this.officeNumber,
            "officeAddress" : this.officeAddress,
            "aboutMe" : this.aboutMe,
          }
      }else if(this.usersProfileData.role == 'expert'){
        jsonData =
          {
            "fullName": this.fullName,
            "nationalCode" : this.nationalCode,
            "email" : this.email,
            "instagramId": this.instagramId,
            "twitterId" : this.twitterId,
            "officeNumber": this.officeNumber,
            "officeAddress" : this.officeAddress,
            "aboutMe" : this.aboutMe,
          }
      }

      await this.$store.dispatch('userManagement/editUserProfile',{id:this.userId,data:jsonData});
      this.$emit('profileEdited',true)
    }
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data());
    this.$store.commit('userManagement/SET_USER_PROFILE', [])
  }
};

</script>
<style>
.v-list-item__title {
  font-family: IranSansLight !important;
}

.col-12 {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
